module.exports = __webpack_public_path__ + "static/pressLogosGroup-bcd7579fbd65c1cbe5037e229fade34c.svg";